module.exports = __webpack_public_path__ + "img/hero.67eae098.svg";